/**
 * Transform from dotted object to classic object
 * Example: { 'a.b.c': 1, 'a.d': 3 } --> { a: { b: { c: 1 }, d: 3 } }
 */
const unflatten = <T, R>(data: T): R => {
  const result: any = {}

  for (const key in data) {
    const keys = key.split('.')
    let current = result

    for (let i = 0; i < keys.length - 1; i++) {
      const k = keys[i]
      const nextKey = keys[i + 1]

      if (!(k in current)) {
        // Check if the next key is a numeric index to decide if we need an array or object
        const num = +nextKey
        current[k] = Number.isInteger(num) && num >= 0 ? [] : {}
      }
      current = current[k]
    }

    current[keys[keys.length - 1]] = data[key]
  }

  return result
}

export const fromDotNotation = <T = any>(data: any): T | T[] =>
  Array.isArray(data) ? data.map((d) => unflatten<any, T>(d)) : unflatten<any, T>(data)
